import { Box } from '@chakra-ui/react';
import { HeadingPortal } from '@mono/layout';
import { FC } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import FileBrowser from '../file-browser/FileBrowser';
import { useCurrentProject } from './hooks';
import { useCurrentOrganization } from '../organizations/hooks';

const ProjectPage: FC = () => {
  const project = useCurrentProject();
  const org = useCurrentOrganization();
  const [params, setParams] = useSearchParams({ path: '' });
  const navigate = useNavigate();

  const setPath = (path: string) => {
    setParams({ path });
  };

  const handleOpenFile = (path: string) => {
    navigate(`/${org?.slug}/p/${project.data?.project.id}/edit?path=${path}`);
  };

  return (
    <Box>
      <HeadingPortal>{project.data?.project.name}</HeadingPortal>
      {project.data?.project.id && (
        <FileBrowser
          projectId={project.data?.project.id}
          path={params.get('path')}
          onChangePath={setPath}
          onOpenFile={handleOpenFile}
        />
      )}
    </Box>
  );
};

export default ProjectPage;
